export default __webpack_public_path__ + "static/footer-contact-bg-a64e1a7e23cc592f4d80b78bd0dc6615.jpeg";